<template>
    <div class="pb-5">
        <div class="text-base mb-10px text-primary">{{ inputLbl.name }}</div>
        <div class="flex w-full items-start">
            <div class="flex-none pr-4 w-28">
                <InputDropdown
                    ref="dropdown"
                    v-model:inputValue="code"
                    :itemList="countryList"
                    :errorInfo="errInfoCode[0]"
                    :isFirstSave="isFirstSave"
                    :inputLbl="{ placeholder: '' }"
                    arrow
                    :hideDetails="true"
                    @onChange="onChange()"
                    :disabled="disabledCountryCode"
                ></InputDropdown>
            </div>
            <div class="flex-auto">
                <input
                    type="tel"
                    class="
                        w-full
                        px-3
                        h-10
                        text-black-1
                        rounded-md
                        appearance-none
                        border
                        ios-fix
                    "
                    :class="[
                        isError ? 'border-red-500' : 'border-primary',
                        disabled ? 'bg-disabled' : 'bg-white',
                    ]"
                    v-model="content"
                    :placeholder="inputLbl.placeholder"
                    :maxlength="inputMaxLength"
                    @input="onChange()"
                    :disabled="disabled"
                />
            </div>
        </div>
        <div class="text-red-500 text-sm pt-1" v-if="isError">
            {{ getErrorMsg }}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";
import { FormHelper } from "@/helper/FormHelper";
//components
import InputDropdown from "./InputDropdown.vue";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isFirstSave (optional) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {String} delimeter (optional) Character seperate number.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputContactNumber",
    props: {
        //v-model
        inputValue: { type: String },
        //props
        minLength: { type: Number },
        maxLength: { type: Number, default: 0 },
        errorInfo: { type: Object, required: true },
        isFirstSave: { type: Boolean, default: true },
        isShowErrorLbl: { type: Boolean, default: false },
        delimeter: { type: String, default: "" },
        //text
        inputLbl: { type: Object, required: true },
        countryCode: { type: Boolean },
        defaultCountryCode: { type: String, default: "66" },
        countryList: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
        },
        disabledCountryCode: {
            type: Boolean,
            default: true
        },
    },
    components: {
        InputDropdown,
    },
    computed: {
        isError: function () {
            if (
                this.isShowErrorLbl &&
                !this.isFirstSave &&
                !this.errorInfo.isValid
            ) {
                return true;
            }
            return false;
        },
        getErrorMsg: function () {
            if (
                this.isShowErrorLbl &&
                !this.isFirstSave &&
                !this.errorInfo.isValid
            ) {
                return this.errorInfo.msg;
            }
            return "";
        },
    },
    data: function () {
        return {
            content: this.inputValue,
            inputMaxLength: null,
            code: "",
            errInfoCode: FormHelper.genErrorInfo(1),
            itemsCountryCode: [],
        };
    },
    watch: {
        countryList: function () {
            this.setDefault();
        },
        inputValue: function () {
            this.validateInput();
        },
    },
    created: function () {
        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }

        this.code = this.defaultCountryCode;
        this.onChange();
    },
    mounted: function () {
        this.validateInput();
    },
    methods: {
        setDefault: function () {
            this.setValues(this.defaultCountryCode, this.inputValue);
        },
        setValues: function (code, mobileNo) {
            this.code = code;
            this.content = mobileNo;
            this.$nextTick(() => {
                this.$refs.dropdown.setValue(this.code);
                this.onChange();
            });
        },
        validateInput: function () {
            if (!this.inputLbl) {
                return false;
            }
            //Set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg("");
            // console.log(this.inputLbl.required && Util.isEmptyStr(this.content))
            //Required
            if (this.inputLbl.required && Util.isEmptyStr(this.content)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required);
                return false;
            }
            //Too short
            if (
                this.inputLbl.too_short &&
                this.minLength &&
                this.content.length < this.minLength
            ) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(
                    Util.stringFormat(this.inputLbl.too_short, this.minLength)
                );
                return false;
            }

            return true;
        },
        onChange: function () {
            let input = Util.isEmptyStr(this.content) ? "" : this.content;
            input = RegxHelper.removeEmoji(input);
            // input = input.replace(/^[^0].*/, '');
            input = RegxHelper.removeNotNumber(input);

            let tel = input;

            if (!Util.isEmptyStr(this.delimeter)) {
                let n1, n2, n3;
                if (input.length <= 3) {
                    // do nothing
                } else if (input.length <= 6) {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    input = n1 + this.delimeter + n2;
                } else {
                    n1 = input.substr(0, 3);
                    n2 = input.substr(3, 3);
                    n3 = input.substr(6);
                    input = n1 + this.delimeter + n2 + this.delimeter + n3;
                }
            }

            if (this.validateInput()) {
                this.content = input;
                this.$emit("update:inputValue", this.code + tel);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.ios-fix {
    -webkit-text-fill-color: #333333;
    opacity: 1; /* required on iOS */
}
</style>
